import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { StudyCenter } from '../entities/study-center';

@Injectable()
export class StudyCenterService extends BaseCrudService<StudyCenter> {

    public uri = '/api/studyCenter/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance StudyCenterService');
    }

    buildSentence(entity?: StudyCenter, event?: LazyLoadEvent): HttpParams {
        if (entity) {
          let query = '';
          query = query.concat(
            entity.code ?
              `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.name ?
              `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.ruc ?
              `ruc${QueryOperator.Contain}${entity.ruc}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.origin ?
              `origin${QueryOperator.Contain}${entity.origin}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.documentNumber ?
              `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.documentDate ?
              `documentDate${QueryOperator.Contain}${entity.documentDate}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          if (entity.studyCenterType && entity.studyCenterType.id) {
            query = query.concat(
              `studyCenterType.id${QueryOperator.Equal}${entity.studyCenterType.id}${QueryOperator.Split}`
            );
          }
          if (entity.supportingDocument && entity.supportingDocument.id) {
            query = query.concat(
              `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
            );
          }
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
          const page = ((event.first + event.rows) / event.rows - 1).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
      }

}



// WEBPACK FOOTER //
// ./src/app/core/services/study-center.service.ts